import cx from 'classnames'
import { useEffect, useRef, useState } from 'react'

import { useClickOutside } from '../../../../hooks'
import { Divider } from '../../../shared/Divider'

import styles from './comments-panel.module.scss'
import Close from './svgs/close'
import { Treeview } from './treeview'

const Tabs = ({ onExit }) => (
  <div className={styles.tabsContainer}>
    <div className={styles.tabs}>
      <div className={styles.title}>Comments</div>
      <button
        className={cx(styles.tab, styles.close)}
        onClick={onExit}
      >
        <Close />
      </button>
    </div>
  </div>
)

export function CommentPanel ({ item, offset, setSelectedIssueId, onCreate, user, read }) {
  const [ addComment, setAddComment ] = useState(false)
  const [ value, setValue ] = useState('')
  const commentRef = useRef(null)
  const [ shift, setShift ] = useState(null)
  const [ open, setOpen ] = useState(false)
  const rightPanelRef = useRef(null)

  const onClickOutside = () => {
    setAddComment(false)
  }

  useClickOutside(commentRef, onClickOutside)

  useEffect(() => {
    if (item) setOpen(true)
    else setOpen(false)

    return () => {
      if (item) {
        const ids = (item.actions || [])
          .reduce((acc, action) =>
            acc.concat(action.comment?.filter(comment => comment.unread)
              ?.map(comment => comment.id) || []),
          item.comment?.filter(comment => comment.unread)
            ?.map(comment => comment.id) || []).filter(Boolean)

        if (ids.length > 0) {
          read(ids)
        }
      }
    }
  }, [ item, read ])

  const renderTabs = (handleSave, onKeyUp, onOpen, openCom, onKeyDown) => {
    if (item) {
      return (
        <Treeview
          user={user}
          item={item}
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
          onOpen={onOpen}
          setValue={setValue}
          open={openCom}
          value={value}
          handleSave={handleSave}
          commentRef={commentRef}
        />
      )
    }
    return null
  }

  const onOpen = id => {
    setAddComment(id)
  }

  const handleKeyDownAction = e => {
    if (e.keyCode === 16 || e.charCode === 16) {
      setShift(true)
    }
    if (e.keyCode === 27) {
      setAddComment(null)
    }
  }

  const onKeyUp = e => {
    if (e.keyCode === 16 || e.charCode === 16) {
      setShift(false)
    }
  }

  const handleSubmitComment = (id, type) => {
    if (value.length > 0) {
      onCreate(value, type, id)
      setValue('')
      setAddComment(null)
    }
  }

  const onEnterComment = (e, type, id) => {
    if (e.keyCode === 13 || (e.charCode === 13 && !shift)) {
      e.preventDefault()
      handleSubmitComment(id || addComment, type)
    }
  }

  return (
    <div
      className={cx(styles.rightPanel, {
        [styles.open]: open
      })}
      style={{ paddingTop: `${offset + 20}px` }}
      ref={rightPanelRef}
    >
      <div>
        <Tabs
          onExit={() => {
            setSelectedIssueId(null)
            setOpen(null)
          }}
        />
      </div>
      <Divider />
      {renderTabs(
        onEnterComment,
        onKeyUp,
        onOpen,
        addComment,
        handleKeyDownAction
      )}
    </div>
  )
}
